export enum EEventParentsUrls {
  BASE_URL = 'event-parents',
  EXPORT = 'export',
}

export const getEventParentsUrl = EEventParentsUrls.BASE_URL;
